import { useState } from 'react';
import ItemsIcon from '../../assets/images/items.png';

import { catalogAPI } from '../../api/catalogAPI';

export default function ItemSeach({ setItemCode, setItemDesc, setItemQty, setItemPrice, setItemExpTime, setItemRemarks, setItemTotal,
                                        modalName}) {

    const [inputKey, setInputKey] = useState('');
    const [items, setItems] = useState([]);

    const onChangeInputKey = (key) => {
        setInputKey(key);

        catalogAPI.searchItems(key).then((data) => setItems(data));
    }

    const onSelectItem = (itemCode, itemDesc, price) => {
        setItemCode(itemCode);
        setItemDesc(itemDesc);
        setItemQty(1);
        setItemPrice(price);
        setItemExpTime("");
        setItemRemarks("");
        setItemTotal(price);

        document.getElementById("modalPOSItemSearch_close").click();
    }

    return (
        <>
            <button className="btn btn-primary form-control" data-bs-toggle="modal" data-bs-target="#modalPOSItemSearch">
                Item <span className="d-none d-lg-inline d-xl-inline d-xxl-inline">Search</span>
                <img src={ItemsIcon} alt="" className="ms-1" />
            </button>

            <div id="modalPOSItemSearch" className="modal fade" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-danger text-center">Search Items</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    Search
                                    <input type="text" className="form-control" value={inputKey}
                                        onInput={(e) => onChangeInputKey(e.target.value)} maxLength="50"
                                        placeholder="Search by item code / description" />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <table className="table table-sm table-hover">
                                        <thead className="thead--color">
                                            <tr>
                                                <td>Item Code</td>
                                                <td>Description</td>
                                                <td className="text-end">Price</td>
                                                <td className="text-center">Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                items.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>{data.itemCode}</td>
                                                        <td>{data.itemDesc}</td>
                                                        <td className="text-end">{data.sellPrice}</td>
                                                        <td className="text-center">
                                                            <button type="button" className="btn btn-sm btn-primary"
                                                                onClick={() => onSelectItem(data.itemCode, data.itemDesc, data.sellPrice)}
                                                                data-bs-toggle="modal" data-bs-target={`#${modalName}`}                                                            >
                                                                Select
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <button className="btn btn-secondary form-control mt-1" data-bs-dismiss="modal"
                                        id="modalPOSItemSearch_close">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}